import { useEffect } from "react";
import {
  Button,
  Popover,
  Checkbox,
  Modal,
  Form,
  Input,
  InputNumber,
  Tabs,
  Row,
  Col,
} from "antd";
import { ReactComponent as HelpIcon } from "../../../assets/images/Help.svg";
import "./CreateVenceConfirm.scss";
import PopoverTitle from "../../common/PopoverTitle";
import { CaretUpFilled, CaretDownFilled } from "@ant-design/icons";

const { TabPane } = Tabs;

function CreateVenceConfirm(props) {
  const {
    onBackButtonClick,
    setCurrentStep,
    currentStepDetails,
    venceStep6Popover,
    createVenceModal,
    venceStep7Popover,
    venceStep8Popover,
    venceInclusionDetails,
    venceExclusionDetails,
  } = props;

  const contentOfStep6Popover = (
    <div>
      <p>Keep editing the vence line until you’re happy with it.</p>
      <p>
        Once you’re done, click <strong>SAVE.</strong>
      </p>
    </div>
  );

  const contentOfStep14Popover = (
    <div>
      <p>
        When you’re happy with it, click <strong>SAVE.</strong>
      </p>
    </div>
  );

  const contentOfSVGContainer = (
    <div>
      <p>
        You can turn off vence edges that parallel physical fences and just
        leave the vence edges that cross-fence the pasture.
      </p>
      <p>
        When you’re done, click <strong>SAVE.</strong>
      </p>
    </div>
  );

  const contentOfInclusionVenceName = (
    <div>
      <p>Give this vence a name.</p>
      <div>
        <Button
          type="primary"
          size="middle"
          style={{ left: "80%" }}
          onClick={() => setCurrentStep((step) => step + 1)}
          className="tutorial-guide-button"
        >
          Next
        </Button>
      </div>
    </div>
  );

  const contentOfExclusionVenceName = (
    <div>
      <p>
        <strong>Give this vence a name</strong> and set its boundaries so that
        the cattle will stay out of the east side of the pasture.
      </p>
      <p>
        Let’s also <strong>increase the shock width to 150 meters</strong> so
        that the entire lupine patch will be uninviting for the cows.
      </p>
    </div>
  );

  const createVenceModalTitle = (
    <div className="header">
      <div className="title">New vence</div>
      <Button
        className="canel-button"
        style={{ marginLeft: "auto" }}
        type="link"
      >
        Cancel
      </Button>
      <Button
        className="save-button"
        onClick={() => {
          // onBackButtonClick();
          setCurrentStep((step) => step + 1);
        }}
      >
        Save
      </Button>
      <Button type="text" icon={<HelpIcon className="help-icon" />} />
    </div>
  );

  function latLng2point(latLng) {
    return {
      x: (latLng.lng + 180) * (256 / 360),
      y:
        256 / 2 -
        (256 *
          Math.log(Math.tan(Math.PI / 4 + (latLng.lat * Math.PI) / 180 / 2))) /
          (2 * Math.PI),
    };
  }

  function poly_gm2svg(gmPaths) {
    let point,
      gmPath,
      svgPath,
      points = [],
      svgPaths = [],
      minX = 256,
      minY = 256,
      maxX = 0,
      maxY = 0;

    for (let pp = 0; pp < gmPaths.length; ++pp) {
      gmPath = gmPaths[pp];
      svgPath = [];
      point = latLng2point(gmPath);
      minX = Math.min(minX, point.x);
      minY = Math.min(minY, point.y);
      maxX = Math.max(maxX, point.x);
      maxY = Math.max(maxY, point.y);
      svgPaths.push([point.x, point.y].join(","));
      points.push(point);
    }
    return {
      path: "M" + svgPaths.join("z M") + "z",
      x: minX,
      y: minY,
      width: maxX - minX,
      height: maxY - minY,
      svgPath: svgPaths.join(" "),
      points: points,
    };
  }

  const fenceCoords = [
    {
      lat: 47.12396257008059,
      lng: -112.1965335890463,
    },
    {
      lat: 47.123991770292534,
      lng: -112.18722095934659,
    },
    {
      lat: 47.12165570268796,
      lng: -112.18580475298673,
    },
    {
      lat: 47.11593190352904,
      lng: -112.18872299639493,
    },
    {
      lat: 47.114179597016275,
      lng: -112.1919416472128,
    },
    {
      lat: 47.1124856458716,
      lng: -112.18996754137784,
    },
    {
      lat: 47.113062427985966,
      lng: -112.19600755676338,
    },
    {
      lat: 47.11463578254446,
      lng: -112.19774020067722,
    },
    {
      lat: 47.11550817218741,
      lng: -112.19998792018846,
    },
    {
      lat: 47.119465546145705,
      lng: -112.19769230334073,
    },
    {
      lat: 47.12080885284903,
      lng: -112.19683399645596,
    },
  ];

  const getSVGCoords = () => {
    if (currentStepDetails.step === 6 || currentStepDetails.step === 7) {
      return venceInclusionDetails.coordinates;
    } else if (currentStepDetails.step === 13) {
      return venceExclusionDetails.coordinates;
    } else {
      return fenceCoords;
    }
  };

  const renderSVG = () => {
    let svgProps = poly_gm2svg(getSVGCoords() || fenceCoords);
    return (
      <svg
        height="300"
        width="560"
        preserveAspectRatio="xMidYMid meet"
        viewBox={`${[
          svgProps.x,
          svgProps.y - 0.0007,
          svgProps.width,
          svgProps.height + 0.0009,
        ].join(" ")}`}
      >
        <g transform="scale(1, 1)">
          {/* <path d={svgProps.path} style={{ fill: "lime", stroke: "purple", strokeWidth: 1 }} /> */}
          <polygon
            points={svgProps.svgPath}
            style={{
              fill: "#ffabab",
              stroke: "#c04758",
              strokeWidth: svgProps.width / 100,
            }}
          />
          {/* {drawLines(svgProps.points, svgProps.width / 100)} */}
          {drawLabels(svgProps.points)}
        </g>
      </svg>
    );
  };

  const drawLines = (points, strokeWidth) => {
    let lines = [];
    for (let i = 0; i < points.length; i++) {
      lines.push(
        <line
          x1={points[i].x}
          y1={points[i].y}
          x2={points[i === points.length - 1 ? 0 : i + 1].x}
          y2={points[i === points.length - 1 ? 0 : i + 1].y}
          style={{
            fill: "#ffabab",
            stroke: "#c04758",
            strokeWidth: strokeWidth,
          }}
          onClick={() => { console.log(points[i]) }}
        />
      );
    }
    return lines;
  }

  const drawLabels = (points) => {
    let labels = [];
    for (let i = 0; i < points.length; i++) {
      let point = points[i];
      let nextPoint = points[i + 1];
      if (i === points.length - 1) {
        nextPoint = points[0];
      }
      if (point && nextPoint) {
        let center = {
          x: (point.x + nextPoint.x) / 2,
          y: (point.y + nextPoint.y) / 2,
        };
        labels.push(
          <>
            <circle
              className={"text"}
              cx={center.x}
              cy={center.y}
              r={0.0003}
              strokeWidth={0.0002}
              onClick={(e) => {
                let text = e.target?.nextElementSibling;
                if(text) text.innerHTML = text.innerHTML === "V" ? "P" : "V";
              }}
            />
            <text
              className={"text"}
              fontSize="0.0003"
              textAnchor="middle"
              alignmentBaseline="middle"
              x={center.x}
              y={center.y}
            >
              V
            </text>
          </>
        );
      }
    }
    for (let i = 0; i < points.length; i++) {
      let point = points[i];
      labels.push(
        <>
          <circle
            className={"index"}
            cx={point.x}
            cy={point.y}
            r={0.0003}
            strokeWidth={0.0002}
          />
          <text
            className={"index"}
            fontSize="0.0003"
            textAnchor="middle"
            alignmentBaseline="middle"
            x={point.x}
            y={point.y}
          >
            {i + 1}
          </text>
        </>
      );
    }
    return labels;
  };

  return (
    <>
      <div className="create-vence-confirm">
        <div className="header">
          <label className="title">Save Vence</label>
          <Button
            type="text"
            style={{ marginLeft: "auto" }}
            icon={<HelpIcon className="help-icon" />}
          />
        </div>
        <div className="create-vence-confirm-body">
          <Popover
            title={PopoverTitle}
            content={
              currentStepDetails.step === 5
                ? contentOfStep6Popover
                : contentOfStep14Popover
            }
            placement="leftTop"
            trigger="hover"
            visible={venceStep6Popover}
          >
            <Button
              block
              className="confirm-button"
              onClick={() => {
                setCurrentStep((step) => step + 1);
              }}
            >
              Save...
            </Button>
          </Popover>
          <Button block className="sub-item">
            Cancel
          </Button>
        </div>
      </div>
      <Modal
        visible={createVenceModal}
        title={createVenceModalTitle}
        footer={null}
        className="create-vence-modal"
        closable={false}
        width={600}
        style={{ height: "450px" }}
        centered
        destroyOnClose={true}
      >
        <div className="body">
          <Tabs centered={true} tabPosition="top" activeKey="1">
            <TabPane tab="INFO" key="1">
              <div className="modal-content">
                <Form layout="vertical" className="create-vence-form">
                  <Row align="bottom" justify="space-between">
                    <Col span={15}>
                      <Form.Item label="Vence Name">
                        <Popover
                          title={PopoverTitle}
                          content={
                            currentStepDetails.step === 6
                              ? contentOfInclusionVenceName
                              : contentOfExclusionVenceName
                          }
                          placement="leftTop"
                          trigger="hover"
                          visible={venceStep7Popover}
                        >
                          <Input />
                        </Popover>
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item>
                        <Checkbox>Alert Outside</Checkbox>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="space-between" style={{ marginTop: "15px" }}>
                    <Col span={12}>
                      <Form.Item label="Shock Width (in meters)">
                        <InputNumber
                          min={15}
                          controls={{
                            upIcon: <CaretUpFilled />,
                            downIcon: <CaretDownFilled />,
                          }}
                          defaultValue={30}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={11}>
                      <Form.Item label="Sound Width (in meters)">
                        <InputNumber
                          min={0}
                          controls={{
                            upIcon: <CaretUpFilled />,
                            downIcon: <CaretDownFilled />,
                          }}
                          defaultValue={10}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <div style={{ width: "100%", color: "#999" }}>
                      <span>Set (V)ence or (P)hysical edge</span>
                    </div>
                    <Popover
                      title={PopoverTitle}
                      content={contentOfSVGContainer}
                      placement="leftTop"
                      trigger="hover"
                      visible={venceStep8Popover}
                    >
                      <div
                        style={{ marginLeft: "-15px", marginTop: "10px" }}
                        className="svg-container"
                      >
                        {renderSVG()}
                      </div>
                    </Popover>
                  </Row>
                </Form>
              </div>
            </TabPane>
            <TabPane tab="DETAIL" key="2">
              <div className="modal-content">Detail</div>
            </TabPane>
          </Tabs>
        </div>
      </Modal>
    </>
  );
}

export default CreateVenceConfirm;
